export function transformCollapsibleTags(content: string): { transformed: string; collapsibles: Map<string, string> } {
  const collapsibles = new Map<string, string>()
  let counter = 0

  const collapsibleRegex = /<collapsible\s+title=["']([^"']+)["']\s*>([\s\S]*?)<\/collapsible>/gi
  const transformed = content.replace(collapsibleRegex, (_match, title, innerContent) => {
    const contentId = `collapsible-${counter++}`
    collapsibles.set(contentId, innerContent.trim())

    const escapedTitle = title
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')

    return `<div class="collapsible-wrapper" data-title="${escapedTitle}" data-content-id="${contentId}"></div>`
  })

  return { transformed, collapsibles }
}
